module.exports = __webpack_public_path__ + "static/media/icon-no-event.773f3e4a.svg";